import { computed, watchEffect } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';

export function usePageTitle(): void {
  const { t } = useI18n();
  const route = useRoute();

  const routeTitlePart = computed(() => {
    const { titleKey, titleKeyMap } = route.meta;
    if (titleKeyMap) {
      const paramValue = route.params[titleKeyMap.param];
      const mapEntry =
        typeof paramValue === 'string'
          ? titleKeyMap.keys[paramValue]
          : undefined;
      if (mapEntry) {
        const keys = Array.isArray(mapEntry) ? mapEntry : [mapEntry];
        return keys.map((k) => t(k).trim()).join(' - ');
      }
    }
    const resolvedKey = typeof titleKey === 'string' ? titleKey : '';
    return resolvedKey ? t(resolvedKey).trim() : '';
  });

  watchEffect(() => {
    const appName = t('generic.backofficeTitle') || 'Back Office';
    document.title = routeTitlePart.value
      ? `${routeTitlePart.value} | ${appName}`
      : appName;
  });
}
